import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG } from 'app/app.config';
import { APP_ROUTES } from 'app/constants';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsComponent {
    private readonly router = inject(Router);

    public readonly version = APP_CONFIG.version;
    public isOpen = false;

    public toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            void this.router.navigate([APP_ROUTES.Help]);
        }
    }
}
